var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newReport"},[_vm._m(0),_c('frontBackaAppraisal_tea')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header flex-align-between"},[_c('span',[_vm._v("我的报告")]),_c('div',{staticClass:"type flex-layout"},[_c('div',{staticClass:"item flex-align-around active-item"},[_vm._v("测评报告")])])])
}]

export { render, staticRenderFns }